// crewbit-admin/src/hooks/useScheduleVocabulary.ts
//
// Schedule Module Phase C C6 — vocab hook (admin pair).
// Mirror of crewbit-mobile/hooks/useScheduleVocabulary.ts; bodies byte-equivalent
// (per feedback_admin_pair_must_match_mobile_body.md).

import { useMemo } from 'react';
import { resolveScheduleVocabulary, type ScheduleVocabulary } from '../lib/scheduleVocabulary';

export type { ScheduleVocabulary } from '../lib/scheduleVocabulary';

export function useScheduleVocabulary(industry: string | null | undefined): ScheduleVocabulary {
  return useMemo(() => resolveScheduleVocabulary(industry), [industry]);
}
